import React, { useEffect, useRef, useState } from 'react'
import { itemSelection } from '../../../models/itemSelection.model'
import { ClearIcon, ItemAddCancelIcon, ItemAddConfirmIcon, ItemAddIcon } from '../Icons'
import CopyToClipboard from '../CopyToClipboard'
import './index.css'


interface TagInputProps {
  label: string
  name: string
  placeholder?: string
  values: itemSelection[]
  handleSelection?: (key: string, value: any) => void
  disabled?: boolean
  inputType?: 'text' | 'number'
}

const TagInput: React.FC<TagInputProps> = ({
  label,
  name,
  placeholder,
  values,
  handleSelection,
  inputType = 'text',
  disabled = false
}) => {

  const [inputMode, setInputMode] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputMode && inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputMode]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value)
  }

  const onConfirm = () => {
    if (!inputValue || inputValue.trim() === '') return
    if (handleSelection) {
      const newTag: itemSelection = { id: '', label: inputValue }
      const newValues = values.some(item => item.label === newTag.label) ? values : [...values, newTag];
      handleSelection(name, newValues)
    }
    setInputValue('')
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onConfirm();
    }
  };

  const onRemove = (label: string) => {
    if (handleSelection) {
      const newValues = values.filter(item => item.label !== label);
      handleSelection(name, newValues)
    }
  }

  return (
    <div className='tag-input-section'>
      <label className='tag-input__label'>{label}</label>

      <div className={`tag-input-items ${disabled ? 'disabled' : ''}`}>
        {values && values.map((item, index) => {
          return (

            <div key={index} className='tag-input-chip'>
              <div className='tag-input-chip_label'>{`${item.label}`}</div>
              <div className='tag-input-chip-actions'>
                <span className='table-column-key__copyicon'>
                  <CopyToClipboard targetText={item.label} />
                </span>
                {!disabled && (
                  <button onClick={() => onRemove(item.label)} className='tag-input-chip-remove'><ClearIcon /></button>
                )}
              </div>
            </div>
          )
        })}
      </div>

      {!disabled && (
        <div className='tag-input-add'>
          <button className='tag-input-add__btn' onClick={() => setInputMode(true)}>
            <ItemAddIcon />
          </button>
          {inputMode && (
            <div className='tag-input-add__box'>
              <input type={inputType} ref={inputRef}
                placeholder={placeholder ? placeholder : ''}
                value={inputValue}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown} />
              <div className='tag-input-add__actions'>
                <button className='tag-input-add__actions-btn' onClick={() => setInputMode(false)}>
                  <ItemAddCancelIcon />
                </button>
                <button className='tag-input-add__actions-btn' onClick={onConfirm}>
                  <ItemAddConfirmIcon />
                </button>
              </div>

            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default TagInput;